import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { Card, CardContent, CardHeader, Checkbox, createTheme, Divider, FormControlLabel, InputAdornment, InputLabel, Radio, TextField, Typography } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import MaskedInput from 'react-text-mask';
import axios from 'src/utils/axios';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import MalzemeSearch from '../../components/Selects/MaterialSearch';
import UrunSearch from '../../components/Selects/ProductSearch';
import VergiDairesiSearch from '../../components/Selects/TaxSearch';

const useStyles = makeStyles((theme) => ({
  root: {},

  fieldsComboDegisim: {
    margin: theme.spacing(0),
    display: 'flex',
  },
  sectionHeader: {
    backgroundColor: '#f8f9fa',
    padding: '10px 12px',
    marginBottom: theme.spacing(3),
    borderLeft: '4px solid #FF9800',
    display: 'flex',
    alignItems: 'center',
    '& h3': { fontSize: '0.85rem', fontWeight: 700, color: '#424242', textTransform: 'uppercase', margin: 0 }
  },
}));
const DegisimArcelikSari = '#FF9800';
const Degisimsiyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: DegisimArcelikSari,
      dark: Degisimsiyah,
      main: Degisimsiyah,
      light: Degisimsiyah
    },
  },
});
const localeMapUrunDegisim = {
  tr: trLocale,
};
function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['T', 'R', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/]}
      placeholderChar={'\u2000'}
      guide={false}
      showMask
    />
  );
}
function Degisim({ className, FisNo, readonly, isUserFault, GUserFault, tasks, GFarkliModelTalebi, isFarkliModelTalebi }) {
  const localeDegisim = "tr";
  const classes = useStyles();
  const [UrunDataDegisim, setUrunDataDegisim] = useState({});
  const [VDDataDegisim, setVDDataDegisim] = useState({});
  const [MusteriTipiData, setMusteriTipiData] = useState([]);
  const [MusteriTipiDataValue, setMusteriTipiDataValue] = useState(0);
  const [UdgNeden, setUdgNeden] = useState([]);
  const [UdgNedenValue, setUdgNedenValue] = useState(0);
  const [UdgTur, setUdgTur] = useState([]);
  const [UdgTurValue, setUdgTurValue] = useState(0);
  const [UdgNedenDetay, setUdgNedenDetay] = useState([]);
  const [UdgNedenDetayValue, setUdgNedenDetayValue] = useState("0");
  const [BankaKodu, setBankaKodu] = useState("");
  const [BankaAdi, setBankaAdi] = useState("");
  const [IBAN, setIBAN] = useState("");
  const [FaturaNo, setFaturaNo] = useState("");
  const [FaturaTarihi, setFaturaTarihi] = useState("");
  const [FaturaTutari, setFaturaTutari] = useState(0);
  const [FaturaAdet, setFaturaAdet] = useState(0);
  const [, setKisaNot] = useState("");
  const [ServisNotu, setServisNotu] = useState("");
  const [TuketiciBilgileriDegisiklikSebebi, setTuketiciBilgileriDegisiklikSebebi] = useState("");
  const [MalzemeDataDegisim, setMalzemeDataDegisim] = useState({});
  const [DegisimTutar, setDegisimTutar] = useState(0);
  const [DekontSahibi, setDekontSahibi] = useState("");
  const [UstModelFarkTutar, setUstModelFarkTutar] = useState(0);
  const [FaturaSira, setFaturaSira] = useState(0);
  const [VergiNumarasi, setVergiNumarasi] = useState("");
  const [TCKimlikNumarasi, setTCKimlikNumarasi] = useState("");
  const [FaturaKontrol, setFaturaKontrol] = useState(false);
  const [UdgUrunTeslimAlindi, setUdgUrunTeslimAlindi] = useState(0);
  const [UserFault, setUserFault] = useState(GUserFault);
  const [FarkliModelTalebi, setFarkliModelTalebi] = useState(GFarkliModelTalebi);
  
  // Güvenli veri erişimi - DegisimData her zaman array ve en az boş obje içerir
  let DegisimDataRaw = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();
  let DegisimData = Array.isArray(DegisimDataRaw) && DegisimDataRaw.length > 0 ? DegisimDataRaw : [{}];

  if (!readonly && (!DegisimDataRaw || DegisimDataRaw.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      const reloaded = loadBaslandiJob();
      DegisimData = Array.isArray(reloaded) && reloaded.length > 0 ? reloaded : [{}];
    }
  }
  const GetMusteriTip = () => {
    axios.get(`/GetArtemisUdgMusteriTip`)
      .then(response => {
        if (response.data.length > 0) {
          setMusteriTipiData(response.data);
        }
      })
  }
  const GetArtemisUdgNeden = () => {
    axios.get(`/GetArtemisUdgNeden`)
      .then(response => {
        if (response.data.length > 0) {
          setUdgNeden(response.data);
          setUdgNedenValue(DegisimData[0]?.UDS_NEDEN || "0");
        }
      })
  }
  const GetArtemisUdgTur = () => {
    axios.get(`/GetArtemisUdgTur`)
      .then(response => {
        if (response.data.length > 0) {
          setUdgTur(response.data);
        }
      })
  }
  useEffect(() => {
    let isMounted = true;
    
    GetMusteriTip();
    GetArtemisUdgNeden();
    GetArtemisUdgTur();
    setMusteriTipiDataValue(DegisimData[0]?.UDS_MUSTERI_TIPI || "0");
    setUdgTurValue(DegisimData[0]?.UDS_TUR || "0");
    if (DegisimData[0]?.UDS_NEDEN > 0) {
      axios.get(`/GetArtemisUdgNedenDetay/` + DegisimData[0]?.UDS_NEDEN)
        .then(response => {
          if (isMounted && response.data.length > 0) {
            setUdgNedenDetay(response.data);
            setUdgNedenDetayValue(DegisimData[0]?.UDS_NEDEN_DETAY || "0");
          }
        })
        .catch(() => {
          // Hata yönetimi
        });
    }
    setDegisimTutar(DegisimData[0]?.UDS_TUTAR || 0);
    setBankaKodu(DegisimData[0]?.UDS_BANKA_KODU || "");
    setBankaAdi(DegisimData[0]?.UDS_BANKA_ADI || "");
    setIBAN(DegisimData[0]?.UDS_IBANNO || "");
    setFaturaNo(DegisimData[0]?.UDS_FATURA_NO || "");
    setFaturaTarihi(DegisimData[0]?.UDS_FATURA_TARIHI || "");
    setFaturaTutari(DegisimData[0]?.UDS_FATURA_TUTARI || 0);
    setFaturaAdet(DegisimData[0]?.UDS_FATURA_ADET || 0);
    setKisaNot(DegisimData[0]?.UDS_KISANOT || "");
    setServisNotu(DegisimData[0]?.UDS_SERVIS_NOTU || "");
    setTuketiciBilgileriDegisiklikSebebi(DegisimData[0]?.UDS_TUKETICI_BILGILERI_DEGISIKLIK_SEBEBI || "");
    setDekontSahibi(DegisimData[0]?.UDS_DEKONT_SAHIBI || "");
    setUstModelFarkTutar(DegisimData[0]?.UDS_UST_MODEL_FARK_TUTAR || 0);
    setFaturaSira(DegisimData[0]?.UDS_FATURA_SIRA || 0);
    setVergiNumarasi(DegisimData[0]?.UDS_VERGI_NUMARASI || "");
    setTCKimlikNumarasi(DegisimData[0]?.UDS_TCKIMLIKNO || "");
    setUdgUrunTeslimAlindi(DegisimData[0]?.UDS_SERVIS_URUNU_TESLIM_ALDI || 0);
    setUrunDataDegisim(DegisimData[0]);
    setVDDataDegisim(DegisimData[0]);
    setMalzemeDataDegisim(DegisimData[0]);
    setFarkliModelTalebi(DegisimData[0]?.MUSTERININ_FARKLI_MODEL_TALEBI);

    if (DegisimData[0]?.UDS_MUSTERI_TIPI === 1 || DegisimData[0]?.UDS_MUSTERI_TIPI === 0) {
      setFaturaKontrol(false);
    } else {
      setFaturaKontrol(true);
    }
    
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [DegisimData[0]?.BasvuruNo]);


  const handleChangeFarkliModelTalebi = (param) => {
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      MUSTERININ_FARKLI_MODEL_TALEBI: param
    };
    saveBaslandiJob(job);
  }

  const handleChangeDegisimNedeni = (e) => {
    axios.get(`/GetArtemisUdgNedenDetay/` + e.target.value)
      .then(response => {
        if (response.data.length > 0) {
          setUdgNedenDetay(response.data);
        }
      })
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_NEDEN: e.target.value || "",
    };
    saveBaslandiJob(job);
    setUdgNedenValue(e.target.value);
  }
  const handleChangeNedenDetay = (e) => {
    setUdgNedenDetayValue(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_NEDEN_DETAY: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeTeslimAlindi = (e) => {
    setUdgUrunTeslimAlindi(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_SERVIS_URUNU_TESLIM_ALDI: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeDegisimTuketiciBilgileriDegisiklikSebebi = (e) => {
    setTuketiciBilgileriDegisiklikSebebi(e.target.value || "");
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_TUKETICI_BILGILERI_DEGISIKLIK_SEBEBI: e.target.value || "",
    };
    saveBaslandiJob(job);
  }
  const handleChangeDegisimServisNot = (e) => {
    setServisNotu(e.target.value || "");
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_SERVIS_NOTU: e.target.value || "",
    };
    saveBaslandiJob(job);
  }
  const handleChangeFaturaAdet = (e) => {
    setFaturaAdet(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_FATURA_ADET: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeFaturaTutar = (e) => {
    setFaturaTutari(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_FATURA_TUTARI: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeFaturaTarihi = (e) => {
    var Deger = moment(e).format('YYYY-MM-DD');
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_FATURA_TARIHI: Deger,
    };
    saveBaslandiJob(job);
    setFaturaTarihi(Deger);
  }
  const handleChangeFaturaNo = (e) => {
    setFaturaNo(e.target.value || "");
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_FATURA_NO: e.target.value || "",
    };
    saveBaslandiJob(job);
  }
  const handleChangeIBAN = (e) => {
    setIBAN(e.target.value || "");
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_IBANNO: e.target.value || "",
    };
    saveBaslandiJob(job);
  }
  const handleChangeBankaAdi = (e) => {
    setBankaAdi(e.target.value || "");
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_BANKA_ADI: e.target.value || "",
    };
    saveBaslandiJob(job);
  }
  const handleChangeBankaKodu = (e) => {
    setBankaKodu(e.target.value || "");
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_BANKA_KODU: e.target.value || "",
    };
    saveBaslandiJob(job);
  }
  const handleChangeTur = (e) => {
    setUdgTurValue(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_TUR: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeMusteriTipi = (e) => {
    if (e.target.value === "1" || e.target.value === "0") {
      setFaturaKontrol(false);
    } else {
      setFaturaKontrol(true);
    }
    setMusteriTipiDataValue(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_MUSTERI_TIPI: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeDegisimTutar = (e) => {
    setDegisimTutar(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_TUR: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeTCKimlikNumarasi = (e) => {
    setTCKimlikNumarasi(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_TCKIMLIKNO: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }


  const setVergiDairesiUrunDegisim = (param) => {
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_VERGI_DAIRESI_ID: param.ID || 0,
      UDS_VERGI_DAIRESI: param.ACIKLAMA || '',
      UDS_VERGI_DAIRESI_KOD: param.KOD || '',
    };
    saveBaslandiJob(job);
    setVDDataDegisim(job);
  }
  const setModelUrunDegisim = (param) => {
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_TALEP_EDILEN_MODEL_KODU: param.MODEL_KODU || 0,
      UDS_TALEP_EDILEN_MODEL: param.ACIKLAMA || '',
      UDS_TALEP_EDILEN_KUL_MODEL_KODU: param.KUL_MODEL_KODU || '',
    };
    saveBaslandiJob(job);
    setUrunDataDegisim(job);
  }
  const setMalzemeUrunDegisim = (param) => {
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_TEMINSIZ_STOK_KUL_KODU: param.MALZEME_STOK_NO || '',
      UDS_TEMINSIZ_STOK: param.ACIKLAMA || '',
    };
    saveBaslandiJob(job);
    setMalzemeDataDegisim(job);
  }
  const handleChangeDekontSahibi = (e) => {
    setDekontSahibi(e.target.value || '');
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_DEKONT_SAHIBI: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeUstModelFarkTutar = (e) => {
    setUstModelFarkTutar(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_UST_MODEL_FARK_TUTAR: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeFaturaSira = (e) => {
    setFaturaSira(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_FATURA_SIRA: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChangeVergiNumarasi = (e) => {
    setVergiNumarasi(e.target.value || "");
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_VERGI_NUMARASI: e.target.value || "",
    };
    saveBaslandiJob(job);
  }
  useEffect(() => {
    if (UserFault === true) {
      isUserFault(1);
    }
    else {
      isUserFault(0);
    }
  }, [UserFault, isUserFault])

  useEffect(() => {
    if (FarkliModelTalebi === true) {
      isFarkliModelTalebi(1);
    }
    else {
      isFarkliModelTalebi(0);
    }
  }, [FarkliModelTalebi, isFarkliModelTalebi])

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={"Ürün Değişim"} />
      <Divider />
      <CardContent className={classes.content}>
        <Typography className={classes.title} color="textSecondary">
          Tüketici Bilgileri Değişiklik Sebebi
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            name="TuketiciBilgileriDegisiklikSebep"
            multiline
            minRows={4}
            fullWidth
            value={TuketiciBilgileriDegisiklikSebebi}
            onChange={handleChangeDegisimTuketiciBilgileriDegisiklikSebebi}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          Vergi Dairesi
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {readonly ?
            <TextField
              type="text"
              value={(VDDataDegisim.UDS_VERGI_DAIRESI_KOD + ' - ' + VDDataDegisim.UDS_VERGI_DAIRESI) || ''}
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
              disabled={readonly}
              variant="outlined"
            />
            :
            <VergiDairesiSearch setVergiDairesi={setVergiDairesiUrunDegisim} value={{
              KOD: VDDataDegisim.UDS_VERGI_DAIRESI_KOD,
              ACIKLAMA: VDDataDegisim.UDS_VERGI_DAIRESI
            } || ''}
              searchParam={''}
            />
          }
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"Vergi Numarası"}
            name="Vergi Numarası"
            multiline
            fullWidth
            value={VergiNumarasi}
            onChange={handleChangeVergiNumarasi}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <div className={classes.policy}>
            <FormControlLabel
              control={<Checkbox color="primary" checked={Boolean(UserFault)} onChange={() => setUserFault(!UserFault)} />}
              label="Kullanıcı Hatası Mevcut" disabled={readonly}
            />
          </div>

        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"TC Kimlik No"}
            name="TC Kimlik No"
            multiline
            fullWidth
            value={TCKimlikNumarasi}
            onChange={handleChangeTCKimlikNumarasi}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <FormControl variant="outlined" className={classes.fieldsComboDegisim}>
            <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{"Müşteri Tipi"}</InputLabel>
            <Select
              native
              onChange={handleChangeMusteriTipi}
              label="Müşteri Tipi"
              disabled={readonly}
              fullWidth
              value={MusteriTipiDataValue}
              labelId="musteritipi_label"
              inputProps={{
                name: "musteritipi_select",
                id: "musteritipi_select"
              }}
            >
              <option value="0" defaultValue="0"></option>
              {MusteriTipiData.map(p => {
                return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
              })}
            </Select>
          </FormControl>
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <FormControl variant="outlined" className={classes.fieldsComboDegisim}>
            <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{"Değişim Nedeni"}</InputLabel>
            <Select
              native
              onChange={handleChangeDegisimNedeni}
              label="Değişim Nedeni"
              fullWidth
              disabled={readonly}
              value={UdgNedenValue}
              labelId="degisimNeden_label"
              inputProps={{
                name: "degisimNeden_select",
                id: "degisimNeden_select"
              }}
            >
              <option value="0" defaultValue="0"></option>
              {UdgNeden.map(p => {
                return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
              })}
            </Select>
          </FormControl>
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <FormControl variant="outlined" className={classes.fieldsComboDegisim}>
            <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{"Değişim Nedeni Detay"}</InputLabel>
            <Select
              native
              onChange={handleChangeNedenDetay}
              label="Değişim Nedeni Detay"
              fullWidth
              disabled={readonly}
              value={UdgNedenDetayValue}
              labelId="degisimNedenDetay_label"
              inputProps={{
                name: "degisimNedenDetay_select",
                id: "degisimNedenDetay_select"
              }}
            >
              <option value="0" defaultValue="0"></option>
              {UdgNedenDetay.map(p => {
                return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
              })}
            </Select>
          </FormControl>
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <FormControl variant="outlined" className={classes.fieldsComboDegisim}>
            <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{"Değişim Türü"}</InputLabel>
            <Select
              native
              onChange={handleChangeTur}
              label="Değişim Türü"
              fullWidth
              disabled={readonly}
              value={UdgTurValue}
              labelId="degisimTur_label"
              inputProps={{
                name: "degisimTur_select",
                id: "degisimTur_select"
              }}
            >
              <option value="0" defaultValue="0"></option>
              {UdgTur.map(p => {
                return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
              })}
            </Select>
          </FormControl>
        </Typography>
        {UdgTurValue === 1 && (
          <Typography variant="h6" component="h2" gutterBottom>
            <div className={classes.policy}>
              <span style={{ marginRight: 8 }}>Müşterinin farklı model talebi var mı?<strong> *</strong></span>
              <br></br>
              <label style={{ marginRight: 16 }}>
                <Radio
                  color="primary"
                  checked={FarkliModelTalebi === true}
                  onChange={() => {
                    setFarkliModelTalebi(true)
                    handleChangeFarkliModelTalebi(true);
                  }
                  }
                  disabled={readonly}
                  name="farkliModelTalebi" // aynı grup
                />
                Evet
              </label>
              <br></br>
              <label>
                <Radio
                  color="primary"
                  checked={FarkliModelTalebi === false}
                  onChange={() => {
                    setFarkliModelTalebi(false)
                    handleChangeFarkliModelTalebi(false);
                  }}
                  disabled={readonly}
                  name="farkliModelTalebi" // aynı grup
                />
                Hayır
              </label>
            </div>
          </Typography>
        )}
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"Servis Notu"}
            name="DegisimServisNot"
            multiline
            minRows={4}
            fullWidth
            value={ServisNotu}
            onChange={handleChangeDegisimServisNot}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>
       
        <Typography variant="h6" component="h2" gutterBottom>
          <FormControl variant="outlined" className={classes.fieldsComboDegisim}>
            <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{"Ürün Teslim Alındı mı?"}</InputLabel>
            <Select
              native
              onChange={handleChangeTeslimAlindi}
              label="Ürün Teslim Alındı mı?"
              fullWidth
              disabled={readonly}
              value={UdgUrunTeslimAlindi}
              labelId="teslimalindi_label"
              inputProps={{
                name: "teslimalindi_select",
                id: "teslimalindi_select"
              }}
            >
              <option value="0">Hayır</option>
              <option value="1">Evet</option>
            </Select>
          </FormControl>
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          Talep Model
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {readonly ?
            <TextField
              type="text"
              value={(UrunDataDegisim.UDS_TALEP_EDILEN_KUL_MODEL_KODU + ' - ' + UrunDataDegisim.UDS_TALEP_EDILEN_MODEL) || ''}
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
              disabled={readonly}
              variant="outlined"
              helperText={UrunDataDegisim.UDS_TALEP_EDILEN_MODEL}
            />
            :
            <UrunSearch setModel={setModelUrunDegisim} value={{
              KUL_MODEL_KODU: UrunDataDegisim.UDS_TALEP_EDILEN_KUL_MODEL_KODU,
              ACIKLAMA: UrunDataDegisim.UDS_TALEP_EDILEN_MODEL
            } || ''}
              searchParam={''}
            />
          }
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          Teminsiz Stok
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {readonly ?
            <TextField
              type="text"
              value={(MalzemeDataDegisim.UDS_TEMINSIZ_STOK_KUL_KODU + ' - ' + MalzemeDataDegisim.UDS_TEMINSIZ_STOK) || ''}
              fullWidth
              required
              InputLabelProps={{
                shrink: true,
              }}
              disabled={readonly}
              variant="outlined"
              helperText={MalzemeDataDegisim.UDS_TEMINSIZ_STOK}
            />
            :
            <MalzemeSearch setMalzeme={setMalzemeUrunDegisim} value={{
              MALZEME_STOK_NO: MalzemeDataDegisim.UDS_TEMINSIZ_STOK_KUL_KODU,
              ACIKLAMA: MalzemeDataDegisim.UDS_TEMINSIZ_STOK
            } || ''}
              searchParam={''}
            />
          }
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"Banka Adı"}
            name="BankaAdı"
            multiline
            fullWidth
            value={BankaAdi}
            onChange={handleChangeBankaAdi}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"Banka Şube Kodu"}
            name="BankaKodu"
            multiline
            fullWidth
            value={BankaKodu}
            onChange={handleChangeBankaKodu}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"IBAN"}
            name="Iban"
            multiline
            fullWidth
            value={IBAN}
            InputProps={{
              inputComponent: TextMaskCustom,
            }}
            onChange={handleChangeIBAN}
            variant="outlined"
            disabled={readonly}
          />
        </Typography>
        {FaturaKontrol ?
          <div>
            <Typography variant="h6" component="h2" gutterBottom>
              <TextField
                label={"Fatura No"}
                name="FaturaNo"
                multiline
                fullWidth
                value={FaturaNo}
                onChange={handleChangeFaturaNo}
                variant="outlined"
                disabled={readonly}
              />
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMapUrunDegisim[localeDegisim]}>
                  <KeyboardDatePicker
                    margin="normal"
                    color="primary"
                    inputVariant="outlined"
                    id="FaturaTarihi"
                    label={"Fatura Tarihi"}
                    invalidDateMessage={'Hatalı Tarih Formatı'}
                    format={'dd.MM.yyyy'}
                    variant="outlined"                    
                    value={FaturaTarihi}
                    disabled={readonly}
                    onChange={handleChangeFaturaTarihi}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <TextField
                name="FaturaTutar"
                label={"Fatura Tutarı"}
                value={FaturaTutari || 0}
                type="number"
                
                onChange={handleChangeFaturaTutar}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      ₺
                    </InputAdornment>
                  ),
                }}
                fullWidth
                variant="outlined"
                disabled={readonly}
              />
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <TextField
                name="FaturaAdet"
                label={"Fatura Adedi"}
                value={FaturaAdet || '0'}
                type="number"
                onChange={handleChangeFaturaAdet}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                variant="outlined"
                disabled={readonly}
              />
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <TextField
                name="FaturaSira"
                label={"Fatura Sıra"}
                value={FaturaSira || '0'}
                type="number"
                onChange={handleChangeFaturaSira}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                variant="outlined"
                disabled={readonly}
              />
            </Typography>
          </div>
          : ""}
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            label={"Dekont Sahibi"}
            name="DekontSahibi"
            multiline
            fullWidth
            value={DekontSahibi}
            onChange={handleChangeDekontSahibi}
            variant="outlined"
            disabled={true}
          />
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            name="UstModelFarkTutar"
            label={"Üst Model Fark Tutar"}
            value={UstModelFarkTutar || ''}
            type="number"
            onChange={handleChangeUstModelFarkTutar}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  ₺
                </InputAdornment>
              ),
            }}
            fullWidth
            variant="outlined"
            disabled={true}
          />
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <TextField
            name="DegisimTutar"
            label={"Tutar"}
            value={DegisimTutar || ''}
            type="number"
            onChange={handleChangeDegisimTutar}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  ₺
                </InputAdornment>
              ),
            }}
            fullWidth
            variant="outlined"
            disabled={true}
          />
        </Typography>
      </CardContent>
    </Card>
  );
}

Degisim.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1
  })
)(Degisim);
